import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApproveVendorWithdrawalRequestComponent } from '../../../../features/vendors/components/vendor-withdrawal-requests/approve-vendor-withdrawal-request/approve-vendor-withdrawal-request.component';
import { DeclineVendorWithdrawalRequestComponent } from '../../../../features/vendors/components/vendor-withdrawal-requests/decline-vendor-withdrawal-request/decline-vendor-withdrawal-request.component';
import { VendorsService } from '../../../../features/vendors/services/vendors.service';

@Component({
  selector: 'app-vendor-withdraw-details',
  templateUrl: './vendor-withdraw-details.component.html',
  styles: ``
})
export class VendorWithdrawDetailsComponent implements OnInit {
  @Output() close = new EventEmitter(false);
  @Output() RequestChanged = new EventEmitter(false);
  @Input() selectedRequestId!: any;
  @Input() Permissions!: any;
  dataLoading: boolean = false;
  RequestDetailes!: any


  constructor(private _dialog: MatDialog,
    private _vendorService: VendorsService) {

  }


  ngOnInit(): void {
    this.Permissions = { can_approve: true, can_reject: true }
  }

  ngOnChanges(changes: any): void {
    if (this.selectedRequestId) {
      this.OnGetRequestDetailes()
    }
  }


  OnApproveRequest() {
    const dialogRef = this._dialog.open(ApproveVendorWithdrawalRequestComponent, {
      width: '540px',
      data: this.selectedRequestId
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.OnGetRequestDetailes()
        this.RequestChanged.emit(true)
      }
    })
  }

  OnDeclineRequest() {
    const dialogRef = this._dialog.open(DeclineVendorWithdrawalRequestComponent, {
      width: '540px',
      data: this.selectedRequestId
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.OnGetRequestDetailes()
        this.RequestChanged.emit(true)
      }
    })
  }


  OnGetRequestDetailes() {
    this.dataLoading = true;
    // let model = { request_id: this.selectedRequestId }
    this._vendorService.GetVendorWithdrawalRequestDetails(this.selectedRequestId).subscribe({
      next: (res: any) => {
        this.dataLoading = false;
        this.RequestDetailes = res.data;
      },
      error: (err: any) => {
        this.dataLoading = false;
      }
    });
  }

}
